import { render } from "./UserSharingInput.vue?vue&type=template&id=072f0b67"
import script from "./UserSharingInput.vue?vue&type=script&lang=ts"
export * from "./UserSharingInput.vue?vue&type=script&lang=ts"
script.render = render

export default script